import * as React from 'react'

export default class PageView extends React.Component<React.ReactNode> {
    render() {
        return (
            <div className="content container page">
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/PageView.tsx